export default __webpack_public_path__ + "ee8bf1939bedade249f404dcb82480fa.apk";